import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";

import { PromoApi } from "../api/PromoApi";
import { useAppStore } from "./AppStore";
import { safeStorage } from "./ssrStorage";

interface PromoState {
	promoInfo: Record<string, string>;
	GenerateCouponCode: (hash: string, identifier: string) => Promise<string | undefined>;
}

const usePromoStore = create<PromoState>()(
	persist(
		devtools((set, get) => ({
			promoInfo: {},
			async GenerateCouponCode(hash, identifier) {
				if (!hash) {
					if (useAppStore.getState().isDebug) console.log(`PromoStore.js - No hash provided`);
					return;
				}

				if (!identifier) {
					if (useAppStore.getState().isDebug) console.log(`PromoStore.js - No identifier provided`);
					return;
				}

				if (get().promoInfo?.[identifier]) {
					//if we have already generated a code, we don't want to generate another one
					if (useAppStore.getState().isDebug) console.log(`PromoStore.js - We already have a code!`);
					return get().promoInfo[identifier];
				}

				const coupon = await PromoApi.GenerateCouponCode(hash);
				if (useAppStore.getState().isDebug) console.log(`PromoStore.js - Generated code:`, coupon);
				set({ promoInfo: { ...get().promoInfo, [identifier]: coupon } });
				return coupon;
			},
		})),
		{
			name: "promo-storage",
			storage: safeStorage,
		},
	),
);

export { usePromoStore };
